export enum RequiredActionType {
  COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING',
}

export interface RequiredAction {
  type: RequiredActionType;
}

export enum ViewAccessType {
  ALLOWED = 'allowed',
  DENIED = 'denied',
}

export type Capabilities = Partial<{
  userManagement: ViewAccessType;
  mcpAccess: ViewAccessType;
}>;

export type Rules = Partial<{
  capabilities: Capabilities;
  viewsRestrictions: ViewsRestrictions;
}>;

export interface OrganizationRoleObject {
  id: string;
  name: string | null;
  rules: Rules;
}

export enum ViewType {
  cohortMarketingPerformance = 'cohortMarketingPerformance',
  calendarInsights = 'calendarInsights',
  cohortChart = 'cohortChart',
  calendarChart = 'calendarChart',
  cohortScanner = 'cohortScanner',
  cohortRetention = 'cohortRetention',
  roiBreakdown = 'roiBreakdown',
  overview = 'overview',
  dashboards = 'dashboards',
  integrations = 'integrations',
  productsCatalog = 'productsCatalog',
}

export enum ContractType {
  fixedProducts = 'fixed_products',
  unlimitedProducts = 'unlimited_products',
}

export type ViewsRestrictions = Partial<Record<ViewType, ViewAccessType>>;

interface Organization {
  id: string;
  name: string;
  currency: string;
  timezone: string;
  paymentOverdue: boolean;
  webhookHash: string;
  contractType: ContractType;
  dataStatus: OrganizationDataStatus;
  isActive: boolean;
  role: OrganizationRoleObject;
}

export interface Profile {
  id: string;
  email: string;
  defaultOrganizationId: string;
  organizations: Organization[];
  analyticsId: string;
  requiredActions: RequiredAction[];
}

export enum OrganizationDataStatus {
  PENDING = 'pending',
  READY = 'ready',
}
